
















import { Vue, Component } from 'nuxt-property-decorator';
import ArrowIcon from '@/components/common/UniversalSearch/images/arrow-right.vue.svg';
import { SEARCH_SUGGESTIONS } from '@/components/common/UniversalSearch/constants';

@Component<UniversalSearchSuggestions>({
  components: {
    ArrowIcon,
  },
})
export default class UniversalSearchSuggestions extends Vue {
  suggestions = SEARCH_SUGGESTIONS;
}
